'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { SunIcon } from './icons/SunIcon'
import { MoonIcon } from './icons/MoonIcon'

export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => { requestAnimationFrame(() => setMounted(true)) }, [])

  // Render a placeholder during SSR to avoid hydration mismatch
  if (!mounted) return <div className="w-8 h-8" aria-hidden />

  const isDark = resolvedTheme === 'dark'

  return (
    <button
      data-component="ThemeToggle"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="flex items-center justify-center w-8 h-8 rounded
        text-steel hover:text-carolina-dark
        dark:text-cream/50 dark:hover:text-carolina
        transition-colors"
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  )
}

